import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import Product from 'emun.shopping/product.model'

export default class PartsOrderDetailsController extends BasicAutoQueryController {
  getQuery() {
    const $ctrl = this;
    return {
      url: `QueryPartsOrders.json`, //?StatusNotEqualTo=Cart',
      criteria: {
        Id: $ctrl.orderId
      },
      pageSize: 1,
      autoLoad: true,
      onLoaded: args => $ctrl.onOrdersLoaded(args)
    };
  }

  onOrdersLoaded(args) {
    const $ctrl = this;
    $ctrl.order = args.first;
    $ctrl.order.lines.forEach(l => l.product = new Product(l.product));
    console.debug("PartsOrderDetailsController.onLoaded", {
      PartsOrderDetailsController: this,
      args
    });
  }
}
